import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import type { StandingsRow } from '../lib/types'

export default function Standings({ leagueId, weekId }: { leagueId: string; weekId: string | null }) {
  const [season, setSeason] = useState<StandingsRow[]>([])
  const [week, setWeek] = useState<any[]>([])

  useEffect(() => {
    ;(async () => {
      const { data } = await supabase
        .from('v_season_standings')
        .select('*')
        .eq('league_id', leagueId)
        .order('total_units', { ascending: false })
        .order('total_points', { ascending: false })
      setSeason((data ?? []) as StandingsRow[])
    })()
  }, [leagueId])

  useEffect(() => {
    if (!weekId) return
    ;(async () => {
      const { data } = await supabase
        .from('weekly_results')
        .select('points, rank, units_earned, league_members(team_name)')
        .eq('league_id', leagueId)
        .eq('week_id', weekId)
        .order('rank')
      setWeek(data ?? [])
    })()
  }, [leagueId, weekId])

  return (
    <div className="standings">
      <section>
        <h3>This week</h3>
        {week.length === 0 ? (
          <p className="muted">Not scored yet.</p>
        ) : (
          <table className="table">
            <thead><tr><th>#</th><th>Team</th><th>Points</th><th>Units</th></tr></thead>
            <tbody>
              {week.map((r, i) => (
                <tr key={i}>
                  <td>{r.rank}</td>
                  <td>{r.league_members?.team_name}</td>
                  <td>{Number(r.points).toFixed(2)}</td>
                  <td>{r.units_earned || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>

      <section>
        <h3>Season</h3>
        {season.length === 0 ? (
          <p className="muted">Nothing yet.</p>
        ) : (
          <table className="table">
            <thead>
              <tr><th>#</th><th>Team</th><th>Units</th><th>Wins</th><th>Points</th></tr>
            </thead>
            <tbody>
              {season.map((r, i) => (
                <tr key={r.member_id}>
                  <td>{i + 1}</td>
                  <td>{r.team_name} <span className="muted">{r.display_name}</span></td>
                  <td><strong>{r.total_units}</strong></td>
                  <td>{r.weekly_wins}</td>
                  <td>{Number(r.total_points).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  )
}
